export default __webpack_public_path__ + "static/media/launch.72bc3668.jpg";